import React from 'react'


// contexts
import { AuthenticationContext } from '../contexts/authentication';

// components
import NavigationBar from '../components/navigation/NavigationBar/NavigationBar.component';
import MainContent from '../core/MainContent/MainContent.component';

class Pages extends React.Component {
    static contextType = AuthenticationContext;

    state = {
        isLoggedIn: sessionStorage.getItem('asiForemanAuthToken') ? true : false
    }

    setAuthenticationStatus = (token = null, refresh = null) => {

        if(token && refresh) {

            sessionStorage.setItem("asiForemanRefreshToken", refresh)
            sessionStorage.setItem("asiForemanAuthToken", token);
            this.setState({ isLoggedIn: true })

        } else {

            sessionStorage.removeItem("asiForemanRefreshToken")
            sessionStorage.removeItem("asiForemanAuthToken")
            this.setState({ isLoggedIn: false })

        }
    }

    render() {

        const { isLoggedIn } = this.state;

        return (<AuthenticationContext.Provider value={{
            isLoggedIn: isLoggedIn,
            setAuthenticationStatus: this.setAuthenticationStatus
        }}>
            <NavigationBar />
            <MainContent />
        </AuthenticationContext.Provider>)
    }
}

export default Pages;